import apiClient from "services/apiClient";

async function editSpecie(id: any, data: any) {
  const url = `/admin/species/${id}`;
  const res = await apiClient.put(url, data);
  return res.data;
}

export default editSpecie;